var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dateselector-container"},_vm._l((_vm.items),function(item,index){return _c('Cell',{key:index,attrs:{"item":item,"selected":item.day == _vm.content},on:{"click":function($event){return _vm.selectDay(item)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }